import { Tasks } from '../../../../utils/types';
import { generateSatisfactionSurveyEmail } from '../../../../email-templates/satisfactionSurvey';
import { generateTransferDataEmail } from '../../../../email-templates/bankTransferData';
import { supabase } from '../../../../supabase';

const surveyLink =
  'https://docs.google.com/forms/d/e/1FAIpQLSdElPpbDOPCz3QSBrNnlrLXjc0uNK0CvBKTm5F19aS9yVhpiw/viewform?usp=dialog';

export const handleCompletedStatus = async (task: Tasks) => {
  // Generate satisfaction survey email instead of completed task email
  const emailContent = generateSatisfactionSurveyEmail({
    task,
    surveyLink,
  });
  const subject = '¡Tu opinión nos ayuda mucho!';

  // Send bank transfer data email if needed
  if (!task.payment_method || !task.payment_method.toLowerCase().includes('card')) {
    try {
      const transferDataEmailContent = generateTransferDataEmail({ task });
      await supabase.functions.invoke('sendEmail', {
        body: JSON.stringify({
          email: task.email,
          subject: 'Tasky - Datos de transferencia',
          content: transferDataEmailContent,
        }),
      });
    } catch (error) {
      console.error('Error in sending bank transfer data email:', error);
      // Continue with the main email even if the bank transfer email fails
    }
  }

  return { emailContent, subject };
};
